export default __webpack_public_path__ + "static/media/01.6a2548cb.jpg";